import React, { useState, useEffect } from 'react'; 
import CollectionFilters from './CollectionFilters';
import CollectionThumbs from './CollectionThumbs';
import FadeIn from "react-lazyload-fadein";
import WithConsumer from '../context/WithConsumer';
import Foot from './Foot';

const Collection = ({context}) => {
    const posts = () => context.posts;
    const item = posts()[0];  
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();

	const ctxDoRender = () => context.doRender;
    const doRender = ctxDoRender();
    
    let pageClass = 'c-page-wrapper state-not-loaded';
    if (pageLoaded == true) {
	    pageClass = 'c-page-wrapper state-loaded';
    }
	if (item && doRender){
		let title;
		if (item.title && item.search === true) {
			if (item.thumbs) {
				title = <><h1 className="c-collection__heading c-collection__heading--primary">{ item.title }</h1><h3 className="c-collection__heading c-collection__heading--secondary">{ item.thumbs.length } products found</h3></>
			} else {
				title = <><h1 className="c-collection__heading c-collection__heading--primary">No results found</h1><h3 className="c-collection__heading c-collection__heading--secondary">Try searching again</h3></>
			}
		} else if (item.title) {
			if (item.banner_show == true && item.banner_srcset && item.banner_src) {
				title = <div className="c-collection__heading c-collection__heading--primary c-collection__heading--no-mobile"></div>
			} else {
				title = <h1 className="c-collection__heading c-collection__heading--primary">{ item.title }</h1>
			}
		} else {
			title = '';
		}
		let designerList = null;
		if (item.designer_list && item.banner_show_designers == 'hidedesc') {
			if (item.designer_list.length > 1) {
				designerList = <div className="c-collection__header__content__bottom">
					<h4 className="c-collection__header__designer-heading">Designers</h4>
					<ul className="c-collection__header__list">
						{item.designer_list.map((thisdesigner,i) => 
							{
								return (
									<li className="c-collection__header__item" key={i} dangerouslySetInnerHTML={ {__html: thisdesigner.name } }></li>
								)
							}
						)}
					</ul>
				</div>
			}
		} else if (item.description && item.banner_show_designers == 'showdesc') {
			designerList = <div className="c-collection__header__content__bottom">
				<div className="c-collection__header__list" dangerouslySetInnerHTML={ {__html: item.description } }></div>
			</div>
		}
		let banner = false;
		if (item.banner_show == true && item.banner_srcset && item.banner_src) {
			banner = <div className="c-collection__header" style={{backgroundColor: item.banner_background}}>
				<div className="c-collection__header__image">
					<FadeIn duration={250}>
						{onload => (
							<img
								src={item.banner_src} 
								srcSet={item.banner_srcset} 
								onLoad={onload}
							/>
						)}
					</FadeIn>
				</div>
				<div className="c-collection__header__content">
					<div className="c-collection__header__content__top">
						<h1 className="c-collection__header__heading">{ item.title }</h1>
						<h3 className="c-collection__header__subheading">{ item.banner_tagline }</h3>
					</div>
					{ designerList }
				</div>
			</div>	
		}
	    return (
		    <div className={pageClass}>
		        <div className="c-collection">
		        	{ banner }
		        	{ title }
		        	{item.description && item.banner_show == false &&
			        	<div className="c-collection__description scope-text scope-text--center" dangerouslySetInnerHTML={ {__html: item.description } }></div>
		        	}
		        	<CollectionFilters></CollectionFilters>
		        	<CollectionThumbs></CollectionThumbs>
		        </div>
		        <Foot></Foot>
			</div>
		);
	}
	return null;

};
export default WithConsumer(Collection);